const state = {
  audioSrc: '',//audio 的播放地址
  lastAudioSrc: '',//上一次的播放链接地址
  audioIsPlaying: false,//audio是否正在播放
  remainingTime: '',//播放剩余时长
}

const mutations = {
  setAudioIsPlaying: (state, flag) => {
    state.audioIsPlaying = flag
    if(!flag){
      state.remainingTime = ''
    }
  },
  setRemainingTime: (state, time) =>{
    state.remainingTime = time.toFixed(0)
  },
}

const actions = {
  setAudioSrc: ({state, commit}, src) => {
    if(src){
      if( src === state.lastAudioSrc){ // 若是同一个音频
        if(state.audioIsPlaying){ // 判断是否正在播放,
          state.audioSrc = ''
          commit('setAudioIsPlaying', false)
        }else {
          state.lastAudioSrc = state.audioSrc = src
          commit('setAudioIsPlaying', true)
        }
      }else { // 如果src不同，则播放
        state.lastAudioSrc = state.audioSrc = src
        commit('setAudioIsPlaying', true)
      }
    }else {
      state.audioSrc = ''
      commit('setAudioIsPlaying', false)
    }
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
